import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_1";
import BlockPrincipal from "../components/block/Block_5";
import BlockSecondary from "../components/block/Block_1";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.[0]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          subtitle2={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbAbout?.[0]?.text}
          image={rpdata?.gallery?.[8]}
          image2={rpdata?.gallery?.[2]}
          image3={rpdata?.gallery?.[5]}
          listAbout={true}
        />
        <ValuesOne
          image1={rpdata?.gallery?.[0]}
          image2={rpdata?.gallery?.[10]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.[6]}

        />
      </div>
    </BaseLayout>
  );
}

export default About;
